// -----------------------------------------
// -------- GENERATED FROM .FX FILE --------
// -----------------------------------------
// Source: src/babylon/shaders/soft_shadow_blur.fragment.fx
import { ShaderStore } from '@inter-ikea-betrakta-babylonjs/core/Engines/shaderStore.js';
const name = 'soft_shadow_blurPixelShader';
const shader = `precision highp float;
varying vec2 vUV;
const int SAMPLE_COUNT = 16;
const float OFFSETS[16] = float[16](
-14.359376738854206,
-12.377929569488517,
-10.396849318746895,
-8.41608382089975,
-6.435576703455285,
-4.455269417428358,
-2.4751038298192056,
-0.4950160492928827,
1.485055021558738,
3.465172537482815,
5.445401742210555,
7.425801606895373,
9.406430666971303,
11.38734672691729,
13.368604221609049,
15.0
);
const float WEIGHTS[16] = float[16](
0.0025041984018900386,
0.00727113041385933,
0.01802730143570455,
0.03816459863275913,
0.06899239816054603,
0.10650359902176183,
0.14039677865797573,
0.15804511975825483,
0.15192860221604398,
0.12471881477578442,
0.0874287482869619,
0.05233640796478044,
0.02675285116432407,
0.011677277520458898,
0.004352222933779603,
0.0008999506551151568
);
uniform highp sampler2D sourceTexture;
uniform vec2 direction;
void main() {
vec4 result = vec4(0.0);
for (int i = 0; i < SAMPLE_COUNT; i++) {
result += texture(sourceTexture, vUV + direction * OFFSETS[i]).r * WEIGHTS[i];
}
gl_FragColor = result;
}
`;
// Sideeffect
ShaderStore.ShadersStore[name] = shader;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const soft_shadow_blurPixelShader = { name, shader };
//# sourceMappingURL=soft_shadow_blur.fragment.js.map